<template>

    <v-page fixed>

        <transition name="modal">
            <v-modal-broadcast-status v-if="showModal === 'status'" />
        </transition>

        <v-page-header icon="fas fa-envelope">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'broadcasts' }">Broadcasts</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="broadcast.name" :title="broadcast.name" @saved="updateBroadcastName" editable />
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-identifier v-if="broadcast" :uuid="broadcast.id" />
            <v-button-toolbar v-if="broadcast">
                <v-button size="sm" btn-style="white" @click.native="$router.push({ name: 'campaigns-messages', params: { id: broadcast.id } })">Messages</v-button>
                <v-button v-if="!broadcast.is_active" size="sm" btn-style="success" @click.native="$store.commit('showModal', 'status')">Schedule Broadcast</v-button>
                <v-button v-else-if="broadcast.is_active && !broadcast.processed_at" size="sm" btn-style="danger" @click.native="$store.commit('showModal', 'status')">Unschedule Broadcast</v-button>
            </v-button-toolbar>
        </v-page-filters>

        <v-page-body>
            <v-step-segment :step="1" />
            <v-step-email :step="2" />
            <v-step-delivery :step="3" />
            <v-step-options :step="4" />
        </v-page-body>

    </v-page>

</template>

<script>

import axios from 'axios';
import CampaignApi from '@api/CampaignApi';
import ModalBroadcastStatus from '@modals/broadcast/ModalBroadcastStatus';
import ProjectApi from '@api/ProjectApi';
import StepDelivery from '@pages/broadcasts-edit/components/StepDelivery';
import StepEmail from '@pages/broadcasts-edit/components/StepEmail';
import StepOptions from '@pages/automations-edit/components/StepOptions';
import StepSegment from '@pages/broadcasts-edit/components/StepSegment';

export default {

    components: {
        'v-modal-broadcast-status': ModalBroadcastStatus,
        'v-step-delivery': StepDelivery,
        'v-step-email': StepEmail,
        'v-step-options': StepOptions,
        'v-step-segment': StepSegment,
    },

    data() {
        return {
            loading: false,
        }
    },

    created() {
        this.$store.commit('campaign/reset');
    },

    mounted() {
        this.reload();
    },

    computed: {

        broadcast() {
            return this.$store.getters['campaign/campaign'];
        },

    },

    methods: {

        reload() {
            this.$store.commit('loading', true);
            let requests = [
                ProjectApi.getProject(this.project.id),
                CampaignApi.getCampaign(this.$route.params.id),
            ];
            axios.all(requests)
                .then(axios.spread((resProject, resCampaign) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('campaign/setCampaign', resCampaign.data.data)
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        updateBroadcastName(name) {
            this.$store.commit('loading', true);
            CampaignApi.updateCampaignName(this.broadcast.id, name)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
